import WixSDK from 'shared/utils/wix-sdk';
import { event as biEvent, error as biError, validateBiEventArgs, ErrorSeverity, Categories, ERROR_EVENT_ID } from './bi-core';
import { logBI } from '@wix/wix-vod-shared/src/common/logger';
import { attempt } from 'shared/utils/attempt';


const VOID_SRC_ID = 71;

function now() {
  return new Date().getTime();
}

function random() {
  return `${now()}-${Math.random()}`;
}

const startTime = now();

function getDefaultParams() {
  return {
    biToken: attempt(() => WixSDK.Utils.getInstanceValue('biToken')), // same as sid, but we use biToken everywhere
    videoInstanceID: attempt(() => WixSDK.Utils.getInstanceId()),
    visitorID: getVisitorId(),
  };
}

export function getVisitorId() {
  return attempt(() => WixSDK.Utils.getInstanceValue('uid')) ||
    attempt(() => WixSDK.Utils.getInstanceValue('aid')) ||
    '';
}

function makeRestriction(fields) {
  return _.mapValues(fields, restriction => (_.isString(restriction) ? { type: restriction } : restriction));
}

function getParamsWithDefaults(eventSchema, params) {
  const defaultParams = getDefaultParams();

  if (!defaultParams.visitorID || !defaultParams.videoInstanceID) {
    throw new Error('Missing visitorID or videoInstanceID'); // eslint-disable-line no-console
  }

  return _(eventSchema.fields)
    .keys()
    .reduce((acc, name) => ({
      ...acc,
      [name]: _.isUndefined(params[name]) ? defaultParams[name] : params[name],
    }), {});
}

function validate(eventSchema, params) {
  validateBiEventArgs(params, _.keys(eventSchema.fields), makeRestriction(eventSchema.fields), eventSchema.id);
}

function getParamsWithObligatoryFields(eventSchema, params) {
  return {
    evid: eventSchema.id,
    ...params,
    adapter: 'video',
    src: VOID_SRC_ID,
    _: random(),
  };
}

function getErrorParams(eventSchema, params) {
  return {
    evid: ERROR_EVENT_ID,
    errc: eventSchema.id,
    errn: eventSchema.name,
    iss: params.iss || 1,
    sev: params.severity || ErrorSeverity.ERROR,
    adapter: 'trg',
    src: VOID_SRC_ID,
    cat: Categories.VIEWER,
    p1: eventSchema.service,
    p2: params.application,
    _: random(),
    ts: now() - startTime,
    ver: '1',
    visitor_id: getVisitorId(),
    msid: attempt(() => WixSDK.Utils.getInstanceValue('biToken')),
  };
}

export function event(eventSchema, eventSpecificParams) {
  let params = getParamsWithDefaults(eventSchema, eventSpecificParams);
  validate(eventSchema, params);

  params = getParamsWithObligatoryFields(eventSchema, params);
  biEvent(params)
    .then(() =>
      logBI({
        eventName: eventSchema.name,
        event: params,
        isDeprecated: true,
      })
  );
}

export function sendError(eventSchema, eventSpecificParams) {
  const params = getErrorParams(eventSchema, eventSpecificParams);
  biError(params)
    .then(() =>
      logBI({
        eventName: eventSchema.name,
        event: params,
        isDeprecated: true,
      })
    );
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-vod.js